import { defineStore } from 'pinia'
import classificacaoTributariaApi from '@/app/services/classificacaoTributaria'

export const useClassificacaoTributariaStore = defineStore('classificacaoTributaria', {
  state: () => ({
    nbs: [],
    indops: [],
    csts: [],
    classificacoes: [],
    loading: false,
  }),

  actions: {
    async carregarNbs(codigo_servico = null) {
      this.loading = true;
      try {
        const params = codigo_servico ? { codigo_servico } : {};
        this.nbs = await classificacaoTributariaApi.listarNbs(params);
      } finally {
        this.loading = false;
      }
    },

    async carregarIndops(nbs) {
      this.indops = [];
      this.csts = [];
      this.classificacoes = [];

      if (!nbs) {
        return;
      }

      this.loading = true;
      try {
        this.indops = await classificacaoTributariaApi.listarIndop({ nbs });
      } finally {
        this.loading = false;
      }
    },

    async carregarCsts({ nbs, indop }) {
      this.csts = [];
      this.classificacoes = [];

      if (!nbs || !indop) {
        return;
      }

      this.loading = true;
      try {
        this.csts = await classificacaoTributariaApi.listarCst({ nbs, indop });
      } finally {
        this.loading = false;
      }
    },

    async carregarClassificacoes({ nbs, indop, cst }) {
      this.classificacoes = [];

      if (!nbs || !indop || !cst) {
        return;
      }

      this.loading = true;
      try {
        this.classificacoes = await classificacaoTributariaApi.listarClassificacoes({ nbs, indop, cst });
      } finally {
        this.loading = false;
      }
    },

    limpar() {
      this.nbs = [];
      this.indops = [];
      this.csts = [];
      this.classificacoes = [];
    },
  },
})